export const formatPhoneNumber = (phoneNumber) => {
    if (phoneNumber == null) {
        return '(--)XXXXX-XXXX';
    }
    if (phoneNumber !== undefined) {
        const phoneNumberRegex = /^(\d{2})(\d{2})(\d{5})(\d{4})$/;
        return phoneNumber.replace(phoneNumberRegex, '+$1 ($2) $3-$4');
    }

    return '';
};
